import styled from "styled-components";
import { theme } from "theme/theme";
import { Table } from "components";
import { Select } from "antd";

export const TextTitle = styled.div(({ theme }) => ({
  fontSize: theme.sizes.lg,
  lineHeight: theme.sizes.lg,
  fontWeight: theme.fontWeight.bold,
  color: theme.colors.text.primary,
}));

export const SelectStyled = styled(Select)<any>(({ theme }) => ({
  width: "100%",
  ".ant-select-selector": {
    alignItems: "center",
    boxShadow: "none",
    border: "none!important",
    padding: "0 12px!important",
  },
  ".ant-select-arrow": {
    top: "50%",
  },
  ".ant-select-selection-overflow .ant-select-selection-item": {
    border: "none",
    borderRadius: 4,
    background: theme.colors.background,
    fontSize: theme.sizes.xs,
    fontWeight: theme.fontWeight.medium,
    lineHeight: "16px",
    padding: "3px 4px 4px",
    marginRight: 8,
  },
  ".ant-select-selection-item": {
    "&span": {
      display: "none",
    },
  },
}));

export const PaginationWrapper = styled.div`
  text-align: center;
  ${theme.media.tablet} {
    display: flex;
    justify-content: end;
    text-align: unset;
  }
`;

export const ContentWrapper = styled.div`
  margin-bottom: 24px;
  ${theme.media.laptopL} {
    margin-bottom: 32px;
  }
`;

export const TableStyled = styled(Table)`
  .ant-table-tbody > tr > td {
    padding: 20px 16px;
  }
  .ant-table-thead > tr > th:first-child {
    padding-left: 24px;
  }
  .ant-table-thead > tr > th:nth-child(8) {
    &:before {
      width: 0px !important;
    }
  }
  .ant-table-thead > tr > th:nth-child(7) {
    &:before {
      width: 0px !important;
    }
  }
  .ant-table-tbody > tr > td:first-child {
    padding-left: 24px;
    border-right: none;
  }
  .ant-table-tbody > tr > td:last-child {
    text-align: right;
  }
  .ant-table-tbody > tr > td {
    background: ${theme.colors.white} !important;
  }
  .ant-table-tbody > tr.ant-table-row:hover > td.ant-table-cell path {
    fill: ${theme.colors.textLink};
    transition: fill 0.3s ease;
  }
  .ant-table-tbody > tr.ant-table-row:hover > td {
    background: #cde3ec !important;
  }
  .ant-table-tbody > tr.ant-table-row:hover > td {
    background: #cde3ec !important;
    cursor: pointer;
  }
`;

export const SituationTableStyled = styled(Table)`
  .ant-table-thead > tr > th {
    padding: 25px 16px 24px;
  }
  .ant-table-thead > tr > th:nth-child(5) {
    padding: 17px 23px 17px 12px;
  }
  .ant-table-tbody > tr > td {
    font-size: 16px;
    line-height: 16px;
    padding: 6px 16px 5px;
  }
  .ant-table-tbody > tr > td:first-child,
  .ant-table-thead > tr > th:first-child {
    padding-left: 14px;
    padding-right: 14px;
  }
`;

export const Dot = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
`;

export const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StressStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #f2f2f2;
  border-radius: 17px;
  div {
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
  }
`;

export const WrapperSizeChange = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
`;

export const TitleContainer = styled.div`
  display: flex;
  margin-bottom: 24px;
  flex-direction: column;
  gap: 24px;
  ${theme.media.tablet} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 0;
  }
`;

export const CreateTitleContainer = styled.div`
  display: flex;
  margin-bottom: 24px;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
  ${theme.media.tablet} {
    align-items: center;
    gap: 0;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  margin-bottom: 24px;
  flex-direction: column;
  gap: 24px;
  ${theme.media.tablet} {
    margin-bottom: 16px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 0;
  }
`;

export const TransmissionTitleContainer = styled.div`
  display: flex;
  margin-bottom: 24px;
  flex-direction: column;
  gap: 12px;
  text-align: center;
  div {
    font-weight: ${theme.fontWeight.medium};
    font-size: ${theme.sizes.sm};
    line-height: ${theme.sizes.sm};
    color: ${theme.colors.text.secondary};
    order: 2;
    width: 100%;
  }
  button {
    order: 1;
  }
  ${theme.media.tablet} {
    gap: 8px;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    div {
      order: 1;
      width: max-content;
    }
    button {
      order: 2;
    }
  }
`;

export const LeftItem = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  max-width: 114px;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  width: 100%;
  text-align: left;
  margin-bottom: 8px;
  ${theme.media.tablet} {
    flex-direction: column;
    gap: 16px;
    justify-content: flex-start;
    max-width: 154px;
    margin-bottom: 0px;
  }
  ${theme.media.desktop} {
    max-width: 214px;
  }
`;

export const RightItem = styled.div`
  flex: 1;
  width: 100%;
`;

export const DateRangeItem = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  .red-text {
    font-weight: 500;
    font-size: 12;
    line-height: 12px;
    color: #fb2121;
    margin: 8px 0px 12px;
  }
  ${theme.media.tablet} {
    flex-direction: row;
    align-items: center;
    .red-text {
      margin: 0px 0px 0px 12px;
    }
  }
`;

export const CheckboxItem = styled.div`
  display: flex;
  width: 224px;
  align-items: center;
  padding: 7px 12px 8px;
  gap: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  div {
    font-weight: 500;
    font-size: 16px;
    line-height: 23px;
  }
`;

export const CheckboxBlock = styled.div`
  margin-left: 2px;
  .left,
  .right {
    display: flex;
    align-items: center;
    gap: 18px;
    width: 100%;
  }
  ${theme.media.tablet} {
    display: flex;
    gap: 18px;
    .left,
    .right {
      width: unset;
    }
  }
`;

export const CheckboxItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  div {
    font-weight: 500;
    font-size: 16px;
    line-height: 23px;
  }
`;

export const LineCheckboxWrapper = styled.div`
  display: flex;
  gap: 6px;
  div {
    font-weight: 500;
    font-size: 16px;
    line-height: 23px;
  }
  > label {
    margin-top: 2px;
    align-items: initial;
    ${theme.media.desktop} {
      margin-top: 4px;
    }
  }
`;
export const BackgroundText = styled.div`
  width: 100%;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  background: #f2f2f2;
  border-radius: 6px;
  padding: 8px 10px;
  ${theme.media.tablet} {
    width: 224px;
  }
`;

export const AudioContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0px 11px;
  border-bottom: 1px solid #f2f2f2;
  ${theme.media.tablet} {
    padding: 12px 16px 11px;
  }
`;

export const AudioWrapper = styled.div`
  flex: 1;
  display: flex;
  gap: 26px;
  .ant-radio-wrapper {
    height: max-content;
    align-items: center;
    display: flex;
  }
  .ant-radio-wrapper::after {
    display: none;
  }
  .ant-radio-wrapper > span:not(.ant-radio) {
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    padding-left: 6px;
    padding-right: 0;
  }
  .ant-radio {
    top: 0;
  }
  .ant-radio-inner {
    border: 2px solid #cccccc;
    width: 20px;
    height: 20px;
  }
  .ant-radio-checked .ant-radio-inner {
    border: 2px solid #cccccc;
    width: 20px;
    height: 20px;
  }
  .ant-radio-inner::after {
    background-color: #2ac769;
    top: calc(50% - 6px);
    left: calc(50% - 6px);
    width: 12px;
    height: 12px;
  }
  .ant-radio:hover .ant-radio-inner,
  .ant-radio:hover .ant-radio-checked .ant-radio-inner {
    border-color: #cccccc;
  }
  ${theme.media.tablet} {
    gap: 50px;
  }
`;

export const ItemsContainer = styled.div<{ direction?: string }>`
  display: flex;
  flex-direction: ${(props) => (props.direction ? props.direction : "column")};
  align-items: flex-start;
  padding: 12px 0px 11px;
  border-bottom: 1px solid #f2f2f2;
  input {
    width: 100%;
  }
  ${theme.media.tablet} {
    flex-direction: row;
    align-items: center;
  }
  ${theme.media.tablet} {
    padding: 12px 16px 11px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  margin-top: 40px;
  justify-content: space-between;
  width: 100%;
  ${theme.media.tablet} {
    width: unset;
    justify-content: flex-end;
    gap: 24px;
  }
`;

export const DownloadButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  width: 100%;
  margin-bottom: 24px;
  button {
    width: 50%;
  }
  ${theme.media.tablet} {
    width: max-content;
    gap: 8px;
    margin-bottom: 0px;
    button {
      width: unset;
    }
  }
`;

export const SingleButtonWrapper = styled.div`
  margin-top: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  button {
    width: 100%;
  }
  div {
    margin-top: 32px;
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    color: #fb4e4e;
    text-decoration: underline;
    cursor: pointer;
  }
  ${theme.media.tablet} {
    button {
      width: unset;
    }
  }
`;

export const DetailsTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 23px;
  .alert {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    border-radius: 8px;
    text-align: center;
    /* background: rgba(235, 195, 0, 0.15);
    color: #997f00; */
    padding: 7px 8px 8px;
    min-height: 55px;
    display: flex;
    div {
      flex: 1;
      align-self: center;
    }
  }
  ${theme.media.tablet} {
    margin-bottom: 16px;
    justify-content: initial;
    gap: 76px;
    .alert {
      flex: 1;
    }
  }
  ${theme.media.desktop} {
    margin-bottom: 12px;
    gap: 148px;
  }
`;

export const Tooltip4AlertMobile = styled.div`
  position: absolute;
  top: 0;
  right: 98px;
  height: max-content;
  width: 173px;
  background: ${theme.colors.white};
  color: ${theme.colors.text.primary};
  font-size: ${theme.sizes.sm};
  font-weight: ${theme.fontWeight.bold};
  line-height: 20px;
  padding: 8px;
  z-index: 100;
  border-radius: 8px;
  border: 1px solid ${theme.colors.border};
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.16);
  &::after {
    content: "";
    position: absolute;
    top: 11px;
    right: -4px;
    height: 7px;
    width: 7px;
    background: ${theme.colors.border};
    transform: rotate(45deg);
  }
  &::before {
    content: "";
    position: absolute;
    top: 11px;
    right: -1px;
    width: 6px;
    height: 10px;
    background: ${theme.colors.white};
    transform: rotate(45deg);
    z-index: 1;
  }
`;

export const SelectionSection = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: max-content;
  gap: 32px;
  margin-bottom: 24px;
  .first-block {
    button {
      display: none;
    }
  }
  .second-block {
  }
  .third-block {
    display: block;
    width: 100%;
    button {
      width: 100%;
    }
  }
  ${theme.media.tablet} {
    .second-block {
      flex: 1;
    }
    .third-block {
      width: unset;
      button {
        width: unset;
      }
    }
  }
  ${theme.media.desktop} {
    flex-direction: row;
    .first-block {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 55px;
      button {
        display: block;
        width: 100px;
      }
    }
    .third-block {
      display: none;
    }
  }
`;

export const WapperSelectTimeForItem = styled.div`
  ${theme.media.mobileM} {
    padding-left: 0px;
    .dleft,
    .dright,
    .dselectright {
      display: flex;
      width: 100%;
    }
    .dright {
      margin-top: 10px;
    }
    .dselectright {
      margin-top: 10px;
    }
    .bor-div-time {
      margin-bottom: 10px;
    }
  }
  ${theme.media.tablet} {
    .bor-div-time {
      align-items: center;
      display: flex;
      margin-bottom: 0px;
    }
    .dleft,
    .dright,
    .dselectright {
      display: flex;
      width: auto;
    }
    .dright {
      margin: auto;
      margin-top: 0px;
    }
    .dselectright {
      margin-top: 0px;
    }
  }
  ${theme.media.laptop} {
    .ant-select-selection-item {
      padding-right: 18px;
    }
  }
`;

export const SelectBlock = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 16px;
  .dright {
    margin-top: 0px;
  }
  button {
    margin-top: 8px;
  }
  .ant-select-selector {
    background-color: #ffffff !important;
  }
  ${theme.media.tablet} {
    align-items: center;
    flex-direction: row;
    gap: 24px;
    button {
      margin-top: 0px;
    }
  }
`;

export const NotifyWrapper = styled.div<{ fullStressCheck?: boolean }>`
  width: 100%;
  font-weight: 700;
  font-size: 12px;
  line-height: 12px;
  svg {
    position: absolute;
    left: -24px;
    bottom: -4px;
  }
  .notify-title {
    color: ${theme.colors.text.primary};
    width: 100%;
    margin: 4px 0px 10px;
  }
  .single-button {
    width: 100%;
    button {
      width: 100%;
    }
  }
  .button-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    button {
      width: ${(props) => (props.fullStressCheck ? "50%" : "100%")};
      min-width: max-content;
    }
    button:disabled {
      background: #e0e0e0;
    }
  }
  ${theme.media.tablet} {
    display: flex;
    align-items: center;
    position: relative;
    margin-left: 30px;
    width: unset;
    .button-wrapper {
      button {
        width: max-content;
      }
    }
    .single-button {
      width: unset;
      button {
        width: max-content;
      }
    }
    .notify-title {
      width: max-content;
      min-width: max-content;
      margin: 0px 4px 0px 0px;
    }
  }
`;

export const CheckboxText = styled.div`
  display: flex;
  gap: 14px;
  align-items: flex-start;
  justify-content: flex-start;
  > div:last-child {
    margin-top: 3px;
  }
`;

export const InfoWrapper = styled.span<any>(({ visible, theme }) => ({
  position: "relative",
  "&::after": {
    content: `''`,
    position: "absolute",
    display: visible ? "block" : "none",
    top: 5,
    right: 23,
    height: 7,
    width: 7,
    background: theme.colors.border,
    transform: "rotate(45deg)",
  },
  "&::before": {
    content: `''`,
    position: "absolute",
    display: visible ? "block" : "none",
    top: 5,
    right: 24,
    width: 6,
    height: 6,
    background: theme.colors.white,
    transform: "rotate(45deg)",
    zIndex: 3,
  },
}));

export const Image = styled.img`
  position: absolute;
  width: 339px;
  top: 36px;
  left: -121px;
  z-index: 2;
  border: 1px solid #cccccc;
  border-radius: 8px;
  height: auto;
  ${theme.media.tablet} {
    width: 408px;
    bottom: unset;
    left: unset;
    top: -36px;
    right: 26px;
  }
`;

export const TagsContainer = styled.div`
  width: 100%;
  height: 89px;
  max-height: 89px;
  padding: 8px;
  border: 1px solid #e0e0e0;
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.09);
  border-radius: 12px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 16px;
  }
  &::-webkit-scrollbar-track {
    margin: 16px 0px 13px;
    border-left: 4px solid ${theme.colors.white};
    border-right: 4px solid ${theme.colors.white};
    background: ${theme.colors.background};
    border-radius: 7px;
  }
  &::-webkit-scrollbar-thumb {
    background: #bdbdbd;
    border-radius: 7px;
    border-left: 4px solid ${theme.colors.white};
    border-right: 4px solid ${theme.colors.white};
  }
  ${theme.media.tablet} {
    height: max-content;
    max-height: 62px;
  }
`;

export const WrapperBtnForm = styled.div`
  padding: 104px 0px 24px;
  border-top: 0;

  button {
    width: 100%;
    padding: 11px 0 13px;
  }

  ${theme.media.tablet} {
    padding: 0px 0px 24px;
    button {
      width: 128px;
      padding: 11px 24px 13px;
    }
  }
`;

export const TableWrapper = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
  ${theme.media.desktop} {
    flex-direction: row;
    gap: 32px;
  }
`;

export const FirstTable = styled.div`
  font-size: 16px;
  line-height: 16px;
  border: 1px solid #cccccc;
  .first-line {
    padding: 8px 16px;
    border-bottom: 1px solid #cccccc;
    background: #f2f2f2;
    font-weight: 700;
  }
  .second-line,
  .third-line {
    display: flex;
    border-bottom: 1px solid #cccccc;
    div {
      padding: 8px 16px;
    }
    > div:first-child {
      border-right: 1px solid #cccccc;
      width: 60%;
    }
  }
  .fourth-line {
    padding: 8px 16px;
    line-height: 24px;
  }
  ${theme.media.tablet} {
    width: 100%;
    .second-line,
    .third-line {
      > div:first-child {
        width: 35%;
      }
    }
  }
  ${theme.media.desktop} {
    width: 50%;
  }
`;

export const SecondTable = styled.div`
  font-size: 16px;
  line-height: 16px;
  border: 1px solid #cccccc;
  .first-line {
    border-bottom: 1px solid #cccccc;
    background: #f2f2f2;
    font-weight: 700;
  }
  .line {
    display: flex;
    border-bottom: 1px solid #cccccc;
    div {
      padding: 8px 16px;
    }
    > div:first-child {
      border-right: 1px solid #cccccc;
      width: 50%;
    }
    > div:last-child {
      padding: 0px 16px 0px 0px;
      margin: auto 0;
      text-align: right;
      flex: 1;
    }
  }
  .line:last-child {
    border-bottom: none;
  }
  ${theme.media.tablet} {
    width: 100%;
    .line {
      > div:first-child {
        width: 60%;
      }
    }
  }
  ${theme.media.desktop} {
    width: 50%;
  }
`;

export const TableContainer = styled.div`
  border: 1px solid #cccccc;
  border-bottom: none;
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  margin-top: 32px;
  margin-bottom: 8px;
  min-width: 770px;
  .header {
    background: #f2f2f2;
    height: max-content;
    ${theme.media.desktop} {
      height: max-content;
    }
  }
  .line {
    display: flex;
    border-bottom: 1px solid #cccccc;
    div:first-child {
      width: 50%;
      border-right: 1px solid #cccccc;
      padding-left: 16px;
      line-height: 77px;
      ${theme.media.desktop} {
        line-height: 51px;
      }
    }
    > div:last-child {
      width: 64px;
      text-align: center;
      padding: 30px 8px;
      ${theme.media.desktop} {
        width: 96px;
        padding: 16px 6px;
      }
    }
    div:nth-child(2) {
      display: flex;
      flex: 1;
      text-align: center;
      div {
        width: 20%;
        line-height: 18px;
        margin: auto 0;
        text-align: center;
        border-right: 1px solid #cccccc;
        justify-content: center;
        ${theme.media.desktop} {
          line-height: 51px;
          margin: 0;
        }
      }
      > div:first-child {
        padding: 21px 9px 20px;
      }
      > div:nth-child(2) {
        padding: 11px 9px 12px;
      }
      > div:nth-child(3) {
        padding: 30px 9px 29px;
      }
      > div:nth-child(4) {
        padding: 11px 9px 12px;
      }
      > div:last-child {
        padding: 21px 9px 20px;
      }
      ${theme.media.desktop} {
        div {
          padding: 0px !important;
        }
      }
    }
  }
  .title {
    background: #e0e0e0;
    font-weight: 700;
    font-size: 16px;
    line-height: 16px;
    width: 100%;
    padding: 8px 16px 8px 8px;
    border-bottom: 1px solid #cccccc;
  }
  .evaluation {
    display: flex;
    border-bottom: 1px solid #cccccc;
    font-weight: 700;
    font-size: 16px;
    height: 32px;
    line-height: 31px;
    color: #ffffff;
    text-align: center;
    div:first-child {
      width: 50%;
      border-right: 1px solid #cccccc;
      > div {
        width: max-content;
        min-width: 80px;
        padding: 0px 12px 0px 14px;
        background: #3b3b3b;
        margin-left: auto;
        border-right: none;
      }
    }
    > div:last-child {
      width: 64px;
      ${theme.media.desktop} {
        width: 96px;
      }
    }
    div:nth-child(2) {
      display: flex;
      flex: 1;
      div {
        width: 20%;
        background: #3b3b3b;
        padding: 0;
        border-right: 1px solid #cccccc;
        justify-content: center;
      }
    }
  }
  .rating {
    display: flex;
    border-bottom: 1px solid #cccccc;
    font-weight: 500;
    font-size: 16px;
    height: 32px;
    line-height: 31px;
    color: #3b3b3b;
    text-align: center;
    > div svg {
      position: relative;
      top: 2px;
    }
    > div div.background {
      background: #e0e0e0 !important;
    }
    > div:first-child {
      width: 50%;
      border-right: 1px solid #cccccc;
      text-align: left;
      padding-left: 16px;
      > div {
        width: 80px;
        margin-left: auto;
        border-right: none;
      }
    }
    > div:last-child {
      width: 64px;
      font-weight: 700;
      ${theme.media.desktop} {
        width: 96px;
      }
    }
    > div:nth-child(2) {
      display: flex;
      flex: 1;
      div {
        width: 20%;
        padding: 0;
        border-right: 1px solid #cccccc;
        justify-content: center;
      }
    }
  }
`;

export const NoteText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  width: 100%;
  color: #666666;
  ${theme.media.tablet} {
    width: unset;
  }
`;

export const StressSituationTitleWrapper = styled.div`
  display: flex;
  justify-content: initial;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  .back {
    border-radius: 50%;
    border: 1px solid #fbfbfb;
    box-shadow: 1px 1px 8px rgb(0 0 0 / 12%);
    cursor: pointer;
  }
  ${theme.media.tablet} {
    margin-bottom: 21px;
  }
  ${theme.media.desktop} {
  }
`;

export const StressSituationContentWrapper = styled.div`
  padding: 16px;
  background: #ffffff;
  border-radius: 8px;
  ${theme.media.desktop} {
    margin-bottom: 24px;
  }
`;

export const FlagSelect = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  span {
    margin-bottom: 2px;
  }
`;

export const BoxContentChart = styled.div`
  display: flex;
  gap: 37px;
  width: 100%;
  flex-wrap: wrap;
  ${theme.media.desktop} {
    flex-wrap: nowrap;
  }
`;

export const BoxItem = styled.div`
  background: #fbfbfb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  position: relative;
  display: flex;
  ${theme.media.tablet} {
    height: 220px;
  }
`;

export const ChartDivider = styled.div`
  padding: 16px 0px;
  margin: 0px 32px;
  background: #cccccc;
  width: 1px;
  height: 100%;
`;

export const ContainerChartText = styled.div`
  transform: rotateY(180deg);
  text-align: center;
  div {
    font-weight: ${theme.fontWeight.bold};
    font-size: 44px;
    line-height: 44px;
    color: #2ac769;
    span {
      font-weight: ${theme.fontWeight.regular};
      font-size: ${theme.sizes.md};
      line-height: 16px;
      padding-left: 1px;
    }
  }
`;

export const Square = styled.div`
  width: 10px;
  height: 10px;
  margin-top: 1px;
`;

export const RadarChartWrapper = styled.div`
  width: 100%;
  p {
    width: 100%;
    margin: 0;
    font-weight: 500;
    font-size: 12px;
    line-height: 17px;
    text-align: center;
  }
  ${theme.media.tablet} {
    width: 47%;
  }
  ${theme.media.desktop} {
    width: 32%;
  }
`;

export const RadarChartItem = styled.div`
  width: 100%;
  height: 280px;
`;

export const HeaderSection = styled.div`
  display: flex;
  gap: 16px;
  .right {
    display: flex;
    height: auto;
    div {
      width: 46px;
      padding: 5px 9px 16px;
      color: #666666;
      background: #f2f2f2;
      border-radius: 2px 2px 0px 0px;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
    }
    > div:first-child {
      border-right: 1px solid #ffffff;
      width: 47px;
    }
  }
  > div:nth-child(2) {
    display: none;
  }
  ${theme.media.desktop} {
    > div:nth-child(2) {
      display: block;
    }
  }
`;

export const ChartContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  .chart-section {
    flex: 1;
  }
  .checkbox-section {
    width: 100%;
    height: 41px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    padding-left: 8px;
    background: #ffffff;
    border-bottom: 1px solid #eeeeee;
    .right {
      display: flex;
      height: auto;
      background: #fafafa;
      div {
        width: 46px;
        padding: 13px 12px 15px 11px;
        height: max-content;
        color: #666666;
        border-radius: 2px 2px 0px 0px;
        font-weight: 500;
        border-bottom: 1px solid #f2f2f2;
      }
      > div:first-child {
        border-right: 1px solid #ffffff;
        padding: 10px 13px;
        line-height: 8px;
        width: 47px;
      }
    }
  }
  .checkbox-section:last-child {
    border-bottom: none;
    .right {
      div {
        border-bottom: none;
      }
    }
  }
  // ${theme.media.tablet} {
  //   .checkbox-section {
  //     width: 328px;
  //   }
  // }
`;

export const CheckboxChartItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  .dot-text {
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    .circle {
      width: 17px;
      height: 17px;
      margin: 1px;
      margin-left: 0px;
      border-radius: 50%;
    }
    .square {
      width: 16px;
      height: 16px;
      margin: 2px;
      margin-left: 0px;
    }
    .triangle {
      width: 0px;
      height: 0px;
      border-right: 9px solid transparent;
      border-left: 9px solid transparent;
      border-bottom: 15.5884572px solid transparent;
    }
  }
`;

export const EmptyStressCheckNotice = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  color: #666666;
  margin-top: 8px;
  width: 100%;
  padding: 0px 8px;
  span {
    font-weight: 700;
  }
  ${theme.media.tablet} {
    margin-top: 32px;
  }
  ${theme.media.desktop} {
    margin-top: 40px;
  }
`;

export const ContainerChart = styled.div`
  height: auto;
  width: 980px;
  font-size: 12px;
  line-height: 12px;
  .customized-tooltip-content {
    width: 192px;
    padding: 5px 6px 6px;
    background: #ffffff;
    border: 1px solid #b7b7b7;
    box-sizing: border-box;
    box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.16);
    border-radius: 6px;
    font-size: 10px;
    line-height: 10px;
    font-weight: ${theme.fontWeight.regular};
    .list {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
    .label {
      color: ${theme.colors.text.secondary};
      font-style: normal;
      margin-bottom: 4px;
    }
    .tooltip-item-wrapper {
      display: flex;
      justify-content: space-between;
      .item-left {
        display: flex;
        line-height: 11px;
        color: ${theme.colors.text.primary};
        span {
          margin-left: 4px;
        }
      }
      .item-right {
        color: ${theme.colors.text.secondary};
      }
    }
  }
  .recharts-active-dot {
    display: none;
  }
  .recharts-tooltip-cursor {
    stroke: #ffffff;
  }
  .icon-descriptions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }
  .icon-descriptions-stacked {
    .description {
      display: flex;
      align-items: center;
      margin-right: 4px;
    }
    .description:last-child {
      margin-right: 0px;
    }
  }
  ${theme.media.tablet} {
    width: 100%;
  }
  ${theme.media.desktop} {
    width: 980px;
  }
  .recharts-tooltip-cursor {
    fill: transparent !important;
    stroke: transparent !important;
  }
`;

export const RadarChartSelectWrapper = styled.form`
  .ant-select-selector {
    background-color: #ffffff !important;
  }
  ${theme.media.tablet} {
    display: flex;
    align-items: center;
    gap: 16px;
  }
`;

export const StressLineChartWrapper = styled.div`
  padding: 16px;
  background: #fbfbfb;
  border-radius: 8px;
  ${theme.media.tablet} {
    padding: 24px;
  }
`;

export const DescriptionHeaderBlock = styled.div`
  display: flex;
  height: auto;
  justify-content: flex-end;
  div {
    width: 46px;
    padding: 5px 9px 16px;
    color: #666666;
    background: #f2f2f2;
    border-radius: 2px 2px 0px 0px;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
  }
  > div:first-child {
    border-right: 1px solid #ffffff;
    width: 47px;
  }
`;

export const DescriptionTable = styled.div`
  .block {
    width: 100%;
  }
  ${theme.media.tablet} {
    display: flex;
    flex-wrap: wrap;
    .block {
      width: calc(100% / 2);
    }
  }
  ${theme.media.laptop} {
    .block {
      width: calc(100% / 3);
    }
  }
`;

export const ChartHeaderGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
  ${theme.media.tablet} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 0;
  }
`;

export const RadarChartContainer = styled.div`
  padding: 16px 16px 24px 16px;
  background: #fbfbfb;
  border-radius: 8px;
  margin-bottom: 16px;
  ${theme.media.tablet} {
    padding: 16px 16px 16px 24px;
  }
`;

export const LineChartHeaderGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  margin-bottom: 16px;
  > div:nth-child(2) {
    > div {
      .bor-div-time {
        > div:first-child {
          margin-bottom: 10px;
        }
      }
    }
  }
  ${theme.media.tablet} {
    > div:first-child {
      margin-bottom: 0px;
    }
    > div:nth-child(2) {
      width: 100%;
      > div {
        justify-content: flex-end;
        .bor-div-time {
          > div:first-child {
            margin-bottom: 0px;
          }
        }
      }
    }
  }
  ${theme.media.desktop} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 0;
    > div:nth-child(2) {
      width: max-content;
    }
  }
`;

export const TableStatisticsWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const TotalHeader = styled.div`
  display: flex;
  margin-bottom: 24px;
  gap: 24px;
  justify-content: space-between;
  align-items: center;
`;

export const WrapperHeader1 = styled.div`
  display: flex;
  > div {
    width: calc(100% / 2);
  }
`;

export const WrapperHeader2 = styled.div`
  display: flex;
  > div {
    width: calc(100% / 3);
  }
`;
